/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Fixed
 *
 * 2 = Percent
 */
export enum VauchersValueTypeEnum {
  Fixed = 1,
  Percent = 2,
}
